<div class="std-modal-container !bg-white drop-shadow-fm-feature-modal rounded-fm-5">
    <div
        class="flex flex-col justify-end items-center max-[600px]:justify-center max-[600px]:h-full max-[600px]:shadow-none max-[600px]:w-full w-[600px] max-[600px]:rounded-none rounded-fm-5 bg-blurple relative !pt-[50px] max-[600px]:!pt-[50px] xxx!pt-[186px] !pb-[40px]">
        <fa-icon
            style="font-size: 20px"
            class="std-modal-close text-white"
            [icon]="faTimes"
            (click)="dialog.close()">
        </fa-icon>
        @if (showHowItWorks) {
            <fa-icon
                style="font-size: 20px"
                class="absolute w-[20px] h-[20px] left-[20px] top-[20px] text-white cursor-pointer"
                [icon]="faArrowLeft"
                (click)="onBackButtonClick()">
            </fa-icon>
        }

        @if (!showHowItWorks) {
            <div class="relative flex flex-col items-center justify-center w-full mb-[50px]">
                <div class="max-w-[80%] mb-[30px] relative">
                    <div
                        class="absolute top-[20%] right-[20%] w-[60%] h-[60%] bg-blurple-3 rounded-full blur-[100px] z-[1]"></div>
                    <div
                        class="text-[50px] text-white font-avenir font-semibold text-center relative shiny-effect"
                        >Focus Now</div
                    >
                    <div
                        class="text-[30px] leading-none text-white font-avenir font-semibold text-center">
                        A new way to focus
                    </div>
                </div>

                <div class="text-base text-white font-avenir font-medium text-center max-w-[80%]">
                    Instantly start a session, match with the first available partner, and begin
                    focusing right away.
                </div>
            </div>

            <div>
                <button
                    class="inline-flex justify-center items-center font-avenir text-sm text-blurple !py-1 !px-10 h-[50px] border-2 bg-white font-semibold hover:!bg-blurple-4 rounded-fm-5 !mb-[15px] shiny-effect-2"
                    (click)="startNowSession()"
                    >Start 50-minute session now<fa-icon
                        class="ml-2"
                        [icon]="faArrowRight"></fa-icon>
                </button>
                <div class="w-full text-center">
                    <a
                        (click)="howItWorksClicked()"
                        target="_blank"
                        class="font-semibold font-avenir text-sm cursor-pointer no-underline text-white hover:text-blurple-3 w-full text-center"
                        >How does it work?</a
                    ></div
                >
            </div>
        } @else {
            <div class="flex flex-col items-center justify-center w-full mb-[50px]">
                <div class="max-w-[80%] mb-[30px] relative">
                    <div
                        class="absolute top-[20%] right-[20%] w-[60%] h-[60%] bg-blurple-3 rounded-full blur-[100px] z-[1]"></div>
                    <div
                        class="text-[50px] text-white font-avenir font-semibold text-center relative"
                        >Focus Now</div
                    >
                    <div
                        class="text-[30px] leading-none text-white font-avenir font-semibold text-center">
                        A new way to focus
                    </div>
                </div>

                <div class="max-w-[80%] bg-blurple-5 text-bluegrey-1 rounded-lg p-[20px]">
                    <div class="text-sm font-avenir font-medium text-left">
                        <b>How it works</b>
                        <ol class="text-sm font-avenir font-medium mb-[10px]">
                            <li
                                >Click "Start 50-min session" In the Focus Now panel; we'll match
                                you with the first available partner</li
                            >
                            <li>Share your goals and start focusing as usual</li>
                        </ol>

                        <div>
                            <b>Note:</b>
                            <ul
                                ><li
                                    >Focus Now respects all matching preferences except activity
                                    type and "Prefer Favorites".</li
                                ><li
                                    >Your session start time will be set to the closest 15-minute
                                    mark, but you can start focusing right away.</li
                                ></ul
                            ></div
                        >
                    </div>
                </div>
            </div>

            <div>
                <button
                    class="inline-flex justify-center items-center font-avenir text-sm text-blurple !py-1 !px-10 h-[50px] border-2 bg-white font-semibold hover:!bg-blurple-4 rounded-fm-5 !mb-[15px] shiny-effect-2"
                    (click)="startNowSession()"
                    >Start 50-minute session now<fa-icon
                        class="ml-2"
                        [icon]="faArrowRight"></fa-icon>
                </button>
                <div class="w-full text-center">
                    <a
                        (click)="learnMore()"
                        target="_blank"
                        href="https://support.focusmate.com/en/articles/9994509-focus-now"
                        class="font-semibold font-avenir text-sm cursor-pointer no-underline text-white hover:text-blurple-3 w-full text-center"
                        >Learn more
                        <fa-icon class="pl-[4px]" [icon]="faUpRightFromSquare"></fa-icon></a
                ></div>
            </div>
        }
    </div>
</div>
